import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/case-study/entrepreneurs/thumb.png"

export function Index() {
  return (
    <Layout
      title="Entrepreneurs’ Organization Networking Success – AI Photo Engagement by Premagic"
      description="See how Entrepreneurs’ Organization (EO) enhanced member networking, engagement, and exclusive event experiences through AI-powered photo sharing and community building."
      metaImage={ThumbnailImage}
      keywords={[
        "Entrepreneurs Organization EO, entrepreneur event networking, business networking photos, EO member engagement, entrepreneur community events, business leader networking, EO chapter events, entrepreneur photo sharing, business networking technology, EO global events, entrepreneur event solutions, business community building, EO networking platform, entrepreneur event management, business leader events, AI photo sharing, community engagement",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Entrepreneurs’ Organization", url: "/case-study/entrepreneurs-organization/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Entrepreneurs’ Organization Networking Success - AI Photo Engagement by Premagic",
            "description": "See how Entrepreneurs’ Organization (EO) enhanced member networking, engagement, and exclusive event experiences through AI-powered photo sharing and community building.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.ENTREPRENEURS_ORGANIZATION} />
    </Layout>
  )
}

export default Index
